export default __webpack_public_path__ + "static/media/developer-flat.a5073348.gif";